import React, { Component } from 'react';
import './components/tenant_profile/TenantProfile.css';
import { connect } from 'react-redux';
import * as referencesActions from '../../actions/referencesActions';
import { browserHistory } from 'react-router';
import TenantLandlordReferenceVerificationForm from './components/TenantLandlordReferenceVerificationForm';
import capitalize from 'capitalize';
import { SyncLoader } from 'halogenium';
import { CSSTransitionGroup } from 'react-transition-group';

export default connect(
  store => {
    return {
      landlord_reference_verification: store.references.landlord_reference_verification,
      showSuccessfulVerificationMessage: store.references.showSuccessfulVerificationMessage,
      showLoader: store.references.showLoader,
    };
  },
  dispatch => {
    return {
      getLandlordReferenceVerification: uuid => {
        dispatch(referencesActions.getLandlordReferenceVerification(uuid));
      },
      putLandlordReferenceVerification: (uuid, values) => {
        dispatch(referencesActions.putLandlordReferenceVerification(uuid, values));
      },
      displayLoader: shouldDisplay => {
        dispatch(referencesActions.displayLoader(shouldDisplay));
      },
    };
  }
)(
  class TenantLandlordReferenceVerification extends Component {
    componentDidMount() {
      const query_params = browserHistory.getCurrentLocation().query;
      if (query_params && query_params.uuid) {
        this.props.displayLoader(true);
        this.props.getLandlordReferenceVerification(query_params.uuid);
      } else {
        browserHistory.push('/dashboard');
      }
    }

    handleSubmit = values => {
      const uuid = this.props.landlord_reference_verification.landlord_reference.verification_token;
      this.props.putLandlordReferenceVerification(uuid, values);
    };

    render() {
      let landlord_first_name = null;
      let tenant_full_name = null;
      let rental_amount = null;
      let length_of_stay = null;

      if (this.props.landlord_reference_verification) {
        landlord_first_name = capitalize(
          this.props.landlord_reference_verification.landlord_reference.name.split(' ')[0]
        );
        tenant_full_name =
          capitalize(this.props.landlord_reference_verification.lead.first_name) +
          ' ' +
          capitalize(this.props.landlord_reference_verification.lead.last_name);
        rental_amount = this.props.landlord_reference_verification.landlord_reference.rental_amount;
        length_of_stay = this.props.landlord_reference_verification.landlord_reference
          .length_of_stay;
      }

      return (
        <div className="container application-container">
          {this.props.showLoader && (
            <div style={{ marginTop: '25px' }}>
              <SyncLoader color="#ff5656" size="12px" />
            </div>
          )}

          {this.props.showSuccessfulVerificationMessage && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    margin: '30px',
                  }}
                >
                  {' '}
                  Tenant Reference Verification{' '}
                </h3>
                <div className="row" style={{ textAlign: 'center' }}>
                  <div style={{ marginTop: '-7px' }}>
                    <h1>Thank you!</h1>
                  </div>

                  <div
                    style={{
                      marginTop: '40px',
                      margin: '40px auto',
                      width: '65%',
                    }}
                  >
                    To learn more about our cloud based software for landlords and property managers
                    please visit <a href="https://yuhu.io">yuhu.io</a>.
                  </div>
                </div>
              </div>
            </CSSTransitionGroup>
          )}

          {this.props.landlord_reference_verification && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    marginBottom: '20px',
                  }}
                >
                  {' '}
                  Tenant Reference Verification{' '}
                </h3>
                <div className="row" style={{ textAlign: 'center' }}>
                  <div>
                    <h3>Hi {landlord_first_name}!</h3>
                    <h4>
                      Your tenant {tenant_full_name} has requested you to verify them as a landlord
                      reference. Please answer the following questions:
                    </h4>
                  </div>
                  <TenantLandlordReferenceVerificationForm
                    onSubmit={this.handleSubmit}
                    rentAmount={rental_amount}
                    length_of_stay={length_of_stay}
                  />
                </div>
              </div>
            </CSSTransitionGroup>
          )}
        </div>
      );
    }
  }
);
